import { MarkdownRenderer } from './MarkdownRenderer';

export interface SummaryMarkdownProps {
  markdown: string;
}

export function SummaryMarkdown({ markdown }: SummaryMarkdownProps) {
  return (
    <div className="rounded-lg border border-slate-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 px-4 py-3 h-full flex flex-col min-h-0">
      <div className="flex-1 min-h-0 overflow-y-auto custom-scrollbar pr-1">
        <MarkdownRenderer markdown={markdown} />
      </div>
    </div>
  );
}
